import { render, staticRenderFns } from "./UploadedFileDetails.vue?vue&type=template&id=23c0beaf&scoped=true"
import script from "./UploadedFileDetails.vue?vue&type=script&lang=js"
export * from "./UploadedFileDetails.vue?vue&type=script&lang=js"
import style0 from "./UploadedFileDetails.vue?vue&type=style&index=0&id=23c0beaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0beaf",
  null
  
)

export default component.exports